import type { ContentPagePageItems } from '#root/api/clients/content/data-contracts'
import type { InjectionKey } from 'vue'

export interface PlpAboveGridBelowHeadingEspotContext {
  eSpotsPending: Ref<boolean>
  eSpot?: ComputedRef<{
    name?: 'above-grid-below-heading'
    items?: ContentPagePageItems
  } | undefined>
}

export const PlpAboveGridBelowHeadingEspotContextKey: InjectionKey<PlpAboveGridBelowHeadingEspotContext> = Symbol('PlpAboveGridBelowHeadingEspotContext')
